<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createEmergencyDrill"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add New</span>
      </b-button>
    </div>

    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="site"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Building"
              label-for="building"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <v-select
                label="name"
                v-model="building"
                placeholder="Select Building"
                :options="buildings"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="emergency_drills"
        details-td-class="m-1 p-1"
        small
        v-if="hasPermission('read_emergency_drill')"
        :per-page="0"
      >
        

        <template #cell(site_data)="row">
          {{
            row.item.site_data ? row.item.site_data.name : ""
          }}
        </template>

        <template #cell(building_data)="row">
          {{
            row.item.building_data ? row.item.building_data.name : ""
          }}
        </template>

        <template #cell(device_data)="row">
          {{
            row.item.building_data ? row.item.building_data.ase_number : ""
          }}
        </template>

        <template #cell(status)="row">
          {{
            row.item.status === true ? "Completed" : "Inprocess"
          }}
        </template>



        
        <template #cell(manage)="row">
          <b-button
            variant="success"
            pill
            size="sm"
            class="mr-50"
            @click="falseAlarm(row.item)"
            v-if="hasPermission('update_emergency_drill')"
            :disabled="row.item.status === true ? true:false"
          >
            Mark as completed
          </b-button>

          
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateEmergencyDrillModal
      @modalClosed="onModalClosed"
      :key="`create-${createEmergencyDrillModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateEmergencyDrillModal from "@/components/emergency_drill/CreateEmergencyDrillModal.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";



export default {
  components: {
    CreateEmergencyDrillModal,
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "site_data", label: "Site" },
        { key: "building_data", label: "Building" },
        { key: "title", label: "Title" },
        { key: "status", label: "status" },
        { key: "created_at", label: "Date/Time" },
        { key: "manage", label: "Actions" },
      ],
      
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      emergency_drills: [],
      emergency_drill: null,
      createEmergencyDrillModalCount: 0,
      searchTypes: [
        { value: 1, name: "Site" },
        { value: 2, name: "Building" },
      ],
      searchType: null,
      name: "",
      site: "",
      sites: [],
      buildings: [],
      building : "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();

    const sites =  await this.getSitesDDL();
    this.sites = sites.data;

    const buildings = await this.getBuildingsDDL();
    this.buildings = buildings.data;
  },
  methods: {
    ...mapActions({
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getEmergencyDrills: "appData/getEmergencyDrills",
      updateEmergencyDrill: "appData/updateEmergencyDrill",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.building = "";
            break;
          case 2:
            this.site = "";
            break;         
        }
      } else {
        this.site = "";
        this.building = "";

      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getEmergencyDrills({
          pageNumber: this.currentPage,      
          site: this.site,      
          building: this.building,
        });
        this.emergency_drills = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createEmergencyDrill() {
      this.createEmergencyDrillModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-emergency-drill-modal");
      });
    },
    async falseAlarm(emergency_drill) {
      try {
        const formData = new FormData();
        formData.append("status", true);
        const res = await this.updateEmergencyDrill({
          payload: formData,
          pk: emergency_drill.id,
        });
        console.log(res.status);
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Emergency Drill Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          await this.fetchPaginatedData();
        }
      } catch (error) {
        this.displayError(error);
      }      
    },

    async deactivateAlarm(emergency_drill) {
      try {
        const formData = new FormData();
        formData.append("status", false);
        const res = await this.updateEmergencyDrill({
          payload: formData,
          pk: emergency_drill.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Emergency Drill Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          await this.fetchPaginatedData();
        }
      } catch (error) {
        this.displayError(error);
      }      
    },

    async removeEmergencyDrill(emergency_drill) {
      this.emergency_drill = emergency_drill;
      try {
        const res = await this.deleteEmergencyDrill({
          pk: this.demergency_drill.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "EmergencyDrill deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
